import { PageOrderEnum } from "@/lib/enum/pageOrder.enum";
import thgService from "@/services/thg/services/thgService";
import { ThgThgControllerFindAllPaginatedParamsGen, ThgThgViewModelGen } from "@/services/thg/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { ImpactTypeEnum } from "@/views/thg/enum/impact-type.enum";
import { Action, getModule, Module } from "vuex-module-decorators";
import { ThgStatusEnum } from "../enum/thg/thg-status.enum";
import { BasePagination, FilterTypes, IPaginationFilterListElement } from "./base-pagination.store";

@Module({
  dynamic: true,
  namespaced: true,
  name: "thgPagination",
  store
})
export class ThePaginationStore extends BasePagination<ThgThgViewModelGen, ThgThgControllerFindAllPaginatedParamsGen> {
  protected _pageOrder: PageOrderEnum = PageOrderEnum.DESCENDING;
  protected _itemsPerPage = 1000;
  protected _totalPages = 0;
  protected _paginationList: ThgThgViewModelGen[] = [];
  protected _currentPage = 1;
  protected _totalItems = 0;
  protected _isLoadAll = true;
  protected _filterList: IPaginationFilterListElement[] = [
    { key: "userId", type: FilterTypes.OBJECT_ID },
    { key: "partnerId", type: FilterTypes.OBJECT_ID },
    { key: "status", type: FilterTypes.ENUM, enum: ThgStatusEnum },
    { key: "impactType", type: FilterTypes.ENUM, enum: ImpactTypeEnum },
    { key: "impactFactor", type: FilterTypes.NUMBER },
    { key: "code", type: FilterTypes.STRING },
    { key: "campaign", type: FilterTypes.STRING },
    { key: "year", type: FilterTypes.NUMBER },
    { key: "isBillingInformationComplete", type: FilterTypes.BOOLEAN },
    { key: "numberplate", type: FilterTypes.STRING },
    { key: "isMultiyear", type: FilterTypes.BOOLEAN }
  ];
  @Action
  protected async loadDocuments(query: ThgThgControllerFindAllPaginatedParamsGen): Promise<any> {
    return thgService.getAllThgsPaginated(query);
  }
}

export const ThgPaginationModule = getModule(ThePaginationStore);
